// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CashSendStartEvent
 */
export var CashSendStart = function () { return ({
    name: "Cash Send Start",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Send",
    }
}); };
/**
 * @see CashSendSubmitEvent
 */
export var CashSendSubmit = function (_a) {
    var entryPoint = _a.entryPoint, externalId = _a.externalId, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Cash Send Submit",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendConfirmEvent
 */
export var CashSendConfirm = function (_a) {
    var isDuplicate = _a.isDuplicate;
    return ({
        name: "Cash Send Confirm",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            is_duplicate: isDuplicate !== undefined && isDuplicate !== null ? isDuplicate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendCancelEvent
 */
export var CashSendCancel = function (_a) {
    var amount = _a.amount, isOffline = _a.isOffline, paymentToken = _a.paymentToken, recipientCount = _a.recipientCount;
    return ({
        name: "Cash Send Cancel",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_offline: isOffline !== undefined && isOffline !== null ? isOffline.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_count: recipientCount !== undefined && recipientCount !== null ? recipientCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendSelectInstrumentEvent
 */
export var CashSendSelectInstrument = function (_a) {
    var instrumentType = _a.instrumentType;
    return ({
        name: "Cash Send SelectInstrument",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            instrument_type: instrumentType !== undefined && instrumentType !== null ? instrumentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendSelectRecipientEvent
 */
export var CashSendSelectRecipient = function (_a) {
    var absoluteIndex = _a.absoluteIndex, contactsCount = _a.contactsCount, isSelected = _a.isSelected, recentRecipientCount = _a.recentRecipientCount, recipientType = _a.recipientType, sectionIndex = _a.sectionIndex;
    return ({
        name: "Cash Send SelectRecipient",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            absolute_index: absoluteIndex !== undefined && absoluteIndex !== null ? absoluteIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contacts_count: contactsCount !== undefined && contactsCount !== null ? contactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_selected: isSelected !== undefined && isSelected !== null ? isSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recent_recipient_count: recentRecipientCount !== undefined && recentRecipientCount !== null ? recentRecipientCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_type: recipientType !== undefined && recipientType !== null ? recipientType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_index: sectionIndex !== undefined && sectionIndex !== null ? sectionIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendTokenizeRecipientEvent
 */
export var CashSendTokenizeRecipient = function (_a) {
    var isSelected = _a.isSelected, recipientType = _a.recipientType, suggestion = _a.suggestion;
    return ({
        name: "Cash Send TokenizeRecipient",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            is_selected: isSelected !== undefined && isSelected !== null ? isSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_type: recipientType !== undefined && recipientType !== null ? recipientType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            suggestion: suggestion !== undefined && suggestion !== null ? suggestion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendReceiveErrorEvent
 */
export var CashSendReceiveError = function (_a) {
    var errorMessage = _a.errorMessage;
    return ({
        name: "Cash Send ReceiveError",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendInitiateWebChallengeEvent
 */
export var CashSendInitiateWebChallenge = function (_a) {
    var flowToken = _a.flowToken, paymentTokens = _a.paymentTokens;
    return ({
        name: "Cash Send InitiateWebChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_tokens: paymentTokens !== undefined && paymentTokens !== null ? paymentTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendViewWebChallengeEvent
 */
export var CashSendViewWebChallenge = function (_a) {
    var flowToken = _a.flowToken, paymentTokens = _a.paymentTokens, resultState = _a.resultState, resultErrorDescription = _a.resultErrorDescription, resultErrorType = _a.resultErrorType;
    return ({
        name: "Cash Send ViewWebChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_tokens: paymentTokens !== undefined && paymentTokens !== null ? paymentTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result_state: resultState !== undefined && resultState !== null ? resultState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result_error_description: resultErrorDescription !== undefined && resultErrorDescription !== null ? resultErrorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result_error_type: resultErrorType !== undefined && resultErrorType !== null ? resultErrorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendNavigateWebChallengeEvent
 */
export var CashSendNavigateWebChallenge = function (_a) {
    var flowToken = _a.flowToken, paymentTokens = _a.paymentTokens, navigationType = _a.navigationType, pageType = _a.pageType;
    return ({
        name: "Cash Send NavigateWebChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_tokens: paymentTokens !== undefined && paymentTokens !== null ? paymentTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            navigation_type: navigationType !== undefined && navigationType !== null ? navigationType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            page_type: pageType !== undefined && pageType !== null ? pageType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendReceiveWebChallengeResponseEvent
 */
export var CashSendReceiveWebChallengeResponse = function (_a) {
    var flowToken = _a.flowToken, paymentTokens = _a.paymentTokens, resultState = _a.resultState, resultErrorType = _a.resultErrorType;
    return ({
        name: "Cash Send ReceiveWebChallengeResponse",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_tokens: paymentTokens !== undefined && paymentTokens !== null ? paymentTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result_state: resultState !== undefined && resultState !== null ? resultState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result_error_type: resultErrorType !== undefined && resultErrorType !== null ? resultErrorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendSendWebChallengeRequestEvent
 */
export var CashSendSendWebChallengeRequest = function (_a) {
    var flowToken = _a.flowToken, paymentTokens = _a.paymentTokens;
    return ({
        name: "Cash Send SendWebChallengeRequest",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_tokens: paymentTokens !== undefined && paymentTokens !== null ? paymentTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendInitiateAdyenChallengeEvent
 */
export var CashSendInitiateAdyenChallenge = function (_a) {
    var flowToken = _a.flowToken, transactionType = _a.transactionType, transactionId = _a.transactionId;
    return ({
        name: "Cash Send InitiateAdyenChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_type: transactionType !== undefined && transactionType !== null ? transactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_id: transactionId !== undefined && transactionId !== null ? transactionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendViewAdyenChallengeEvent
 */
export var CashSendViewAdyenChallenge = function (_a) {
    var flowToken = _a.flowToken, transactionType = _a.transactionType, transactionId = _a.transactionId;
    return ({
        name: "Cash Send ViewAdyenChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_type: transactionType !== undefined && transactionType !== null ? transactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_id: transactionId !== undefined && transactionId !== null ? transactionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendCompleteAdyenChallengeEvent
 */
export var CashSendCompleteAdyenChallenge = function (_a) {
    var flowToken = _a.flowToken, transactionType = _a.transactionType, transactionId = _a.transactionId, errorDescription = _a.errorDescription, errorType = _a.errorType;
    return ({
        name: "Cash Send CompleteAdyenChallenge",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_type: transactionType !== undefined && transactionType !== null ? transactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_id: transactionId !== undefined && transactionId !== null ? transactionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_description: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendReceiveAdyenChallengeResponseEvent
 */
export var CashSendReceiveAdyenChallengeResponse = function (_a) {
    var flowToken = _a.flowToken, transactionType = _a.transactionType, transactionId = _a.transactionId, errorIsRetryable = _a.errorIsRetryable, errorCode = _a.errorCode, errorDescription = _a.errorDescription;
    return ({
        name: "Cash Send ReceiveAdyenChallengeResponse",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_type: transactionType !== undefined && transactionType !== null ? transactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_id: transactionId !== undefined && transactionId !== null ? transactionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_is_retryable: errorIsRetryable !== undefined && errorIsRetryable !== null ? errorIsRetryable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_description: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendSendAdyenChallengeRequestEvent
 */
export var CashSendSendAdyenChallengeRequest = function (_a) {
    var flowToken = _a.flowToken, transactionType = _a.transactionType, transactionId = _a.transactionId;
    return ({
        name: "Cash Send SendAdyenChallengeRequest",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_type: transactionType !== undefined && transactionType !== null ? transactionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_id: transactionId !== undefined && transactionId !== null ? transactionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendSelectPaymentTypeEvent
 */
export var CashSendSelectPaymentType = function (_a) {
    var currentPaymentType = _a.currentPaymentType, currentPaymentCurrency = _a.currentPaymentCurrency, newPaymentType = _a.newPaymentType, newPaymentCurrency = _a.newPaymentCurrency, newPaymentBalanceOverZero = _a.newPaymentBalanceOverZero, status = _a.status, source = _a.source;
    return ({
        name: "Cash Send SelectPaymentType",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            current_payment_type: currentPaymentType !== undefined && currentPaymentType !== null ? currentPaymentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_payment_currency: currentPaymentCurrency !== undefined && currentPaymentCurrency !== null ? currentPaymentCurrency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_payment_type: newPaymentType !== undefined && newPaymentType !== null ? newPaymentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_payment_currency: newPaymentCurrency !== undefined && newPaymentCurrency !== null ? newPaymentCurrency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_payment_balance_over_zero: newPaymentBalanceOverZero !== undefined && newPaymentBalanceOverZero !== null ? newPaymentBalanceOverZero.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashSendOpenPaymentTypeSelectorEvent
 */
export var CashSendOpenPaymentTypeSelector = function (_a) {
    var currentPaymentType = _a.currentPaymentType, currentPaymentCurrency = _a.currentPaymentCurrency, selectorType = _a.selectorType, source = _a.source;
    return ({
        name: "Cash Send OpenPaymentTypeSelector",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Send",
            current_payment_type: currentPaymentType !== undefined && currentPaymentType !== null ? currentPaymentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_payment_currency: currentPaymentCurrency !== undefined && currentPaymentCurrency !== null ? currentPaymentCurrency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selector_type: selectorType !== undefined && selectorType !== null ? selectorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRequestStartEvent
 */
export var CashRequestStart = function () { return ({
    name: "Cash Request Start",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Request",
    }
}); };
/**
 * @see CashRequestSubmitEvent
 */
export var CashRequestSubmit = function (_a) {
    var entryPoint = _a.entryPoint, externalId = _a.externalId, profileDirectoryFlowToken = _a.profileDirectoryFlowToken;
    return ({
        name: "Cash Request Submit",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Request",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            profile_directory_flow_token: profileDirectoryFlowToken !== undefined && profileDirectoryFlowToken !== null ? profileDirectoryFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRequestEnterAmountEvent
 */
export var CashRequestEnterAmount = function (_a) {
    var amount = _a.amount, entryMethod = _a.entryMethod;
    return ({
        name: "Cash Request EnterAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Request",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_method: entryMethod !== undefined && entryMethod !== null ? entryMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRequestReceiveErrorEvent
 */
export var CashRequestReceiveError = function (_a) {
    var errorMessage = _a.errorMessage;
    return ({
        name: "Cash Request ReceiveError",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Request",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRequestCompleteEvent
 */
export var CashRequestComplete = function () { return ({
    name: "Cash Request Complete",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Request",
    }
}); };
/**
 * @see CashRequestCancelEvent
 */
export var CashRequestCancel = function (_a) {
    var amount = _a.amount, isOffline = _a.isOffline, paymentToken = _a.paymentToken, recipientCount = _a.recipientCount;
    return ({
        name: "Cash Request Cancel",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Request",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_offline: isOffline !== undefined && isOffline !== null ? isOffline.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_count: recipientCount !== undefined && recipientCount !== null ? recipientCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashDepositStartEvent
 */
export var CashDepositStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Deposit Start",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Deposit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashDepositCanceledEvent
 */
export var CashDepositCanceled = function () { return ({
    name: "Cash Deposit Canceled",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositEnterAmountEvent
 */
export var CashDepositEnterAmount = function (_a) {
    var amount = _a.amount, currency = _a.currency, entryMethod = _a.entryMethod, flowToken = _a.flowToken, options = _a.options;
    return ({
        name: "Cash Deposit EnterAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Deposit",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency: currency !== undefined && currency !== null ? currency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_method: entryMethod !== undefined && entryMethod !== null ? entryMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            options: options !== undefined && options !== null ? options.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashDepositRequestEvent
 */
export var CashDepositRequest = function (_a) {
    var isRetry = _a.isRetry, externalId = _a.externalId, flowToken = _a.flowToken;
    return ({
        name: "Cash Deposit Request",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Deposit",
            is_retry: isRetry !== undefined && isRetry !== null ? isRetry.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashDepositReceiveErrorEvent
 */
export var CashDepositReceiveError = function (_a) {
    var errorMessage = _a.errorMessage, errorIsRetryable = _a.errorIsRetryable, flowToken = _a.flowToken;
    return ({
        name: "Cash Deposit ReceiveError",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Deposit",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_is_retryable: errorIsRetryable !== undefined && errorIsRetryable !== null ? errorIsRetryable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashDepositCompleteEvent
 *
 * @deprecated Removed from clients as of 3.93. See CAT-333.
 */
export var CashDepositComplete = function () { return ({
    name: "Cash Deposit Complete",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositViewP2PRedirectEvent
 *
 * @deprecated No longer in use.
 */
export var CashDepositViewP2PRedirect = function () { return ({
    name: "Cash Deposit ViewP2PRedirect",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositAcceptP2PRedirectEvent
 *
 * @deprecated No longer in use.
 */
export var CashDepositAcceptP2PRedirect = function () { return ({
    name: "Cash Deposit AcceptP2PRedirect",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositDeclineP2PRedirectEvent
 *
 * @deprecated No longer in use.
 */
export var CashDepositDeclineP2PRedirect = function () { return ({
    name: "Cash Deposit DeclineP2PRedirect",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositViewPendingConfirmationEvent
 */
export var CashDepositViewPendingConfirmation = function () { return ({
    name: "Cash Deposit ViewPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositConfirmPendingConfirmationEvent
 */
export var CashDepositConfirmPendingConfirmation = function () { return ({
    name: "Cash Deposit ConfirmPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositDismissPendingConfirmationEvent
 */
export var CashDepositDismissPendingConfirmation = function () { return ({
    name: "Cash Deposit DismissPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Deposit",
    }
}); };
/**
 * @see CashDepositSelectInstrumentEvent
 */
export var CashDepositSelectInstrument = function (_a) {
    var flowToken = _a.flowToken, instrumentType = _a.instrumentType;
    return ({
        name: "Cash Deposit SelectInstrument",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Deposit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            instrument_type: instrumentType !== undefined && instrumentType !== null ? instrumentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawStartEvent
 */
export var CashWithdrawStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw Start",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawViewedEvent
 */
export var CashWithdrawViewed = function (_a) {
    var entryMethod = _a.entryMethod, flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw Viewed",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            entry_method: entryMethod !== undefined && entryMethod !== null ? entryMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawCancelEvent
 */
export var CashWithdrawCancel = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw Cancel",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawDepositPreferenceViewedEvent
 */
export var CashWithdrawDepositPreferenceViewed = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw DepositPreferenceViewed",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawDepositPreferenceSelectedEvent
 */
export var CashWithdrawDepositPreferenceSelected = function (_a) {
    var depositPreference = _a.depositPreference, flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw DepositPreferenceSelected",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            deposit_preference: depositPreference !== undefined && depositPreference !== null ? depositPreference.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawDepositPreferenceBackEvent
 */
export var CashWithdrawDepositPreferenceBack = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw DepositPreferenceBack",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawEnterAmountEvent
 */
export var CashWithdrawEnterAmount = function (_a) {
    var amount = _a.amount, currency = _a.currency, entryMethod = _a.entryMethod, flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw EnterAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency: currency !== undefined && currency !== null ? currency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_method: entryMethod !== undefined && entryMethod !== null ? entryMethod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawSaveAmountEvent
 */
export var CashWithdrawSaveAmount = function (_a) {
    var flowToken = _a.flowToken, amount = _a.amount, currency = _a.currency;
    return ({
        name: "Cash Withdraw SaveAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency: currency !== undefined && currency !== null ? currency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawDismissAmountEvent
 */
export var CashWithdrawDismissAmount = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw DismissAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawViewConfirmationEvent
 */
export var CashWithdrawViewConfirmation = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw ViewConfirmation",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawRequestEvent
 */
export var CashWithdrawRequest = function (_a) {
    var isRetry = _a.isRetry, isLegacyEndpoint = _a.isLegacyEndpoint, externalId = _a.externalId, flowToken = _a.flowToken, depositPreference = _a.depositPreference;
    return ({
        name: "Cash Withdraw Request",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            is_retry: isRetry !== undefined && isRetry !== null ? isRetry.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_legacy_endpoint: isLegacyEndpoint !== undefined && isLegacyEndpoint !== null ? isLegacyEndpoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            deposit_preference: depositPreference !== undefined && depositPreference !== null ? depositPreference.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawReceiveErrorEvent
 */
export var CashWithdrawReceiveError = function (_a) {
    var errorMessage = _a.errorMessage, flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw ReceiveError",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawCompleteEvent
 */
export var CashWithdrawComplete = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw Complete",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawViewKeypadEvent
 */
export var CashWithdrawViewKeypad = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash Withdraw ViewKeypad",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashWithdrawViewPendingConfirmationEvent
 */
export var CashWithdrawViewPendingConfirmation = function () { return ({
    name: "Cash Withdraw ViewPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Withdraw",
    }
}); };
/**
 * @see CashWithdrawConfirmPendingConfirmationEvent
 */
export var CashWithdrawConfirmPendingConfirmation = function () { return ({
    name: "Cash Withdraw ConfirmPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Withdraw",
    }
}); };
/**
 * @see CashWithdrawDismissPendingConfirmationEvent
 */
export var CashWithdrawDismissPendingConfirmation = function () { return ({
    name: "Cash Withdraw DismissPendingConfirmation",
    parameters: {
        cdf_entity: "Cash",
        cdf_action: "Withdraw",
    }
}); };
/**
 * @see CashWithdrawSelectInstrumentEvent
 */
export var CashWithdrawSelectInstrument = function (_a) {
    var flowToken = _a.flowToken, instrumentType = _a.instrumentType;
    return ({
        name: "Cash Withdraw SelectInstrument",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "Withdraw",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            instrument_type: instrumentType !== undefined && instrumentType !== null ? instrumentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRecurringDepositEditEvent
 */
export var CashRecurringDepositEdit = function (_a) {
    var option = _a.option;
    return ({
        name: "Cash RecurringDeposit Edit",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "RecurringDeposit",
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRecurringDepositCompleteEvent
 */
export var CashRecurringDepositComplete = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash RecurringDeposit Complete",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "RecurringDeposit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRecurringDepositUpdateAmountEvent
 */
export var CashRecurringDepositUpdateAmount = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash RecurringDeposit UpdateAmount",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "RecurringDeposit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashRecurringDepositReceiveErrorEvent
 */
export var CashRecurringDepositReceiveError = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Cash RecurringDeposit ReceiveError",
        parameters: {
            cdf_entity: "Cash",
            cdf_action: "RecurringDeposit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
